import { Record } from "immutable";

import {
  PremiumTrialMeta,
  trialMetaInitialState
} from "./meta/PremiumTrialMeta";
import TrialsState, { TrialsStateType } from "./trials/TrialsState";

export type PremiumTrialsStateSliceType = {
  trials: TrialsStateType;
  meta: PremiumTrialMeta;
};

export default class PremiumTrialStateSlice extends Record({
  trials: new TrialsState(),
  meta: trialMetaInitialState
}) {}
